import { BusinessLine } from 'src/app/shared/models/businessLine-model';

export interface LoadBalanceLine {
  businessLine: BusinessLine;
  /** Nome del FormControl del peso nel form di ogni operatore. */
  control: string;
  label: string;
}

export interface LoadBalanceLineGroup {
  id: string;
  label: string;
  lines: LoadBalanceLine[];
}

/**
 * Le linee con un peso per operatore, divise nelle stesse macroaree del catalogo servizi della Web App.
 * Una nuova businessline si aggiunge qui (e in `businessLineWeights`), senza toccare il template.
 */
export const LOAD_BALANCE_GROUPS: LoadBalanceLineGroup[] = [
  {
    id: 'caregiving',
    label: 'Caregiving',
    lines: [
      { businessLine: BusinessLine.BABYSITTER, control: 'weightBB', label: 'Babysitter' },
      { businessLine: BusinessLine.PETSITTER, control: 'weightPET', label: 'Petsitter' },
      { businessLine: BusinessLine.NURSE, control: 'weightNURSE', label: 'Badanti' },
      { businessLine: BusinessLine.COLF, control: 'weightCOLF', label: 'Colf' },
      {
        businessLine: BusinessLine.CAREGIVER_CONSULT,
        control: 'weightCAREGIVER_CONSULT',
        label: 'Supporto caregiver',
      },
    ],
  },
  {
    id: 'medicina',
    label: 'Medicina',
    lines: [
      {
        businessLine: BusinessLine.VIDEO_CONSULTATION,
        control: 'weightVIDEO_CONSULTATION',
        label: 'Video consulto',
      },
      {
        businessLine: BusinessLine.IN_PERSON,
        control: 'weightIN_PERSON',
        label: 'Visita medica di persona',
      },
    ],
  },
  {
    id: 'well-being',
    label: 'Well-being',
    lines: [
      { businessLine: BusinessLine.PSYCHOLOGIST, control: 'weightPSYCHOLOGIST', label: 'Psicologi' },
      { businessLine: BusinessLine.NUTRITIONIST, control: 'weightNUTRITIONIST', label: 'Nutrizionisti' },
      { businessLine: BusinessLine.COACH, control: 'weightCOACH', label: 'Coach' },
      { businessLine: BusinessLine.LONGEVITY, control: 'weightLONGEVITY', label: 'Longevity' },
    ],
  },
];

export const LOAD_BALANCE_LINES: LoadBalanceLine[] = LOAD_BALANCE_GROUPS.reduce(
  (all, group) => all.concat(group.lines),
  [] as LoadBalanceLine[]
);
